(function( ){


	var NavScrollFixed = function( )
	{
		var _this = this , i ;

		var target = document.getElementsByClassName( "js-nav-scroll-fixed" )[0] ;
		var container = document.getElementsByClassName( "js-nav-scroll-fixed-container" )[0] ;

		if( !target || !container ) {
			if( /localhost/.test(location.hostname) ){
				console.warn("Fixedさせる対象のナビ、もしくはコンテナが見つかりません。");
			}
			return ;
		}

		var fixed = target.cloneNode( true ) ;
		container.insertBefore( fixed , container.firstChild ) ;

		fixed.style.display = "none" ;
		fixed.style.pointerEvents = "auto" ;

		var onScroll = function( evt )
		{
			var scrollY = window.pageYOffset ;

			var targetY = target.offsetTop ;
			var parent = target.offsetParent ;
			while( parent && parent != document.body )
			{
				targetY += parent.offsetTop ;
				parent = parent.offsetParent ;
			}
			targetY *= FitContents.zoomScale ;

			if( targetY <= scrollY )
			{
				fixed.style.display = NavScrollFixed.EMPTY ;
				target.style.visibility = NavScrollFixed.HIDDEN ;
				target.mode = fixed.mode = "fixed" ;
			}
			else
			{
				fixed.style.display = NavScrollFixed.NONE ;
				target.style.visibility = NavScrollFixed.EMPTY ;
				target.mode = fixed.mode = "default" ;
			}
		}

		window.addEventListener( "scroll" , onScroll ) ;
		onScroll( ) ;

		//------------------------------------------------
		//クローンしたposition:fixed用のナビに、アンカー処理を付与するために、１度アンカー追加メソッドを呼んでいます。
		var AnchorScroll = window.AnchorScroll ;
		if( AnchorScroll ) {
			AnchorScroll.add( ) ;
		}
	}
	NavScrollFixed.HIDDEN = "hidden" ;
	NavScrollFixed.NONE = "none" ;
	NavScrollFixed.EMPTY = "" ;


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;

	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;

	document.readyState === "complete"
		? setTimeout( function(){ new NavScrollFixed( ) ; }, 1 )
		: document.addEventListener( "DOMContentLoaded", function(){ new NavScrollFixed( ) ; } ) ;

})();
